export const ABSTRACT_MODULE_ID = "abstract";

export const ABSTRACT_STEP_MODES = Object.freeze({
  DISABLED: 0,
  BEFORE_PAYMENT: 3,
  AFTER_PAYMENT: 7,
});

export const POST_PAYMENT_ABSTRACT_FORM_STEP = 8;

export const normalizeAbstractStepNumber = (abstractStepNumber) => {
  const numericStep = Number(abstractStepNumber);
  if (!Number.isNaN(numericStep)) {
    return numericStep;
  }

  const normalizedLabel = String(abstractStepNumber || "")
    .trim()
    .toUpperCase()
    .replace(/&/g, "AND")
    .replace(/\s+/g, " ");

  if (normalizedLabel === "REGISTER AND PAY") {
    return ABSTRACT_STEP_MODES.BEFORE_PAYMENT;
  }

  if (normalizedLabel === "PAY AND REGISTER") {
    return ABSTRACT_STEP_MODES.AFTER_PAYMENT;
  }

  return ABSTRACT_STEP_MODES.DISABLED;
};

export const REGISTRATION_FLOW_STEPS = [
  { id: "personal", step: 1, label: "Personal" },
  { id: "address", step: 2, label: "Address" },
  {
    id: ABSTRACT_MODULE_ID,
    step: ABSTRACT_STEP_MODES.BEFORE_PAYMENT,
    label: "Paper/Abstract",
    module: true,
  },
  { id: "affiliation", step: 4, label: "Affiliation" },
  { id: "category", step: 5, label: "Category" },
  { id: "summary", step: 6, label: "Summary" },
  { id: "payment", step: 7, label: "Payment" },
  {
    id: "post-payment-abstract",
    step: POST_PAYMENT_ABSTRACT_FORM_STEP,
    label: "Registered Paper/Abstract",
    module: true,
  },
];

export const REGISTRATION_MODULES = [
  {
    id: ABSTRACT_MODULE_ID,
    label: "Paper/Abstract",
    stepModes: ABSTRACT_STEP_MODES,
  },
];

export const isAbstractModuleEnabled = (abstractStepNumber) =>
  normalizeAbstractStepNumber(abstractStepNumber) ===
    ABSTRACT_STEP_MODES.BEFORE_PAYMENT ||
  normalizeAbstractStepNumber(abstractStepNumber) ===
    ABSTRACT_STEP_MODES.AFTER_PAYMENT;

export const isInlineAbstractStepEnabled = (abstractStepNumber) =>
  normalizeAbstractStepNumber(abstractStepNumber) ===
  ABSTRACT_STEP_MODES.BEFORE_PAYMENT;

export const isPostPaymentAbstractEnabled = (abstractStepNumber) =>
  normalizeAbstractStepNumber(abstractStepNumber) ===
  ABSTRACT_STEP_MODES.AFTER_PAYMENT;

export const shouldSkipInlineAbstractStep = (abstractStepNumber) =>
  !isInlineAbstractStepEnabled(abstractStepNumber);

export const isPostPaymentAbstractAvailable = ({
  abstractStepNumber,
  paid,
}) => isPostPaymentAbstractEnabled(abstractStepNumber) && (paid === true || paid === "true");

export const shouldApplyAbstractDiscount = ({
  abstractStepNumber,
  wantsToSubmitAbstract,
}) =>
  (isInlineAbstractStepEnabled(abstractStepNumber) &&
    wantsToSubmitAbstract === true) ||
  isPostPaymentAbstractEnabled(abstractStepNumber);

export const getActiveRegistrationSteps = (abstractStepNumber) =>
  REGISTRATION_FLOW_STEPS.filter(
    (step) =>
      (step.id !== ABSTRACT_MODULE_ID ||
        isInlineAbstractStepEnabled(abstractStepNumber)) &&
      (step.id !== "post-payment-abstract" ||
        isPostPaymentAbstractEnabled(abstractStepNumber)),
  );

export const getProgressDisplayStep = (step) => step;

export const getNextStepAfterAddress = (abstractStepNumber) =>
  isInlineAbstractStepEnabled(abstractStepNumber) ? 3 : 4;

export const getPreviousStepBeforeAffiliation = (abstractStepNumber) =>
  isInlineAbstractStepEnabled(abstractStepNumber) ? 3 : 2;
